export const columnSchema = [
  { width: 34, field: 'channel', displayName: 'Channel', type: 'string' },
  { width: 34, field: 'name', displayName: 'Name', type: 'string' },
  { width: 95, field: 'createdUserId', displayName: 'Created By', type: 'string' },
  { width: 120, field: 'createdOn', displayName: 'Imported On', type: 'datetime' },
  // { width: 95, field: 'requestedOpportunityStatus', displayName: 'Opportunity Status', type: 'string' }, // Hiding for now
  { width: 65, field: 'acceptedCount', displayName: 'Accepted Opportunities', type: 'number' },
  { width: 65, field: 'rejectedCount', displayName: 'Rejected Opportunities', type: 'number' },
  { width: 70, field: 'id', displayName: 'Rejected Import ID', type: 'number', sortIndex: 0, sortOrder: 'desc' },
];